function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import c from 'classnames';
const Block = props => {
  const {
    children,
    className,
    tightLineHeight,
    padding = 'small',
    ...rest
  } = props;
  const classes = c('Block o-background--grey', className, {
    'Block--padding-medium': padding === 'medium',
    'Block--padding-large': padding === 'large',
    'Block--tight-line-height': tightLineHeight
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: classes
  }), children);
};
const Divider = () => {
  return /*#__PURE__*/React.createElement("hr", {
    className: "Block__Divider"
  });
};
Block.Divider = Divider;
export default Block;